import { FC } from "react";
import { Span } from "@goodfill/ui-components";
import { CustomerApplicationException } from "@goodfill/domain-customer-application-types/src/customerApplicationSubmission";

type ApplicationExceptionsListProps = {
  exceptions?: CustomerApplicationException[];
};
export const ApplicationExceptionsList: FC<ApplicationExceptionsListProps> = ({ exceptions }) => (
  <>
    <Span font={"semibold"} size={"base"}>
      Exceptions
    </Span>
    {exceptions?.length ? (
      exceptions.map(({ exceptionMessage }, index) => (
        <div key={`application-exception-${index}`} className="flex flex-col w-full border-b border-neutral-110">
          <Span>{exceptionMessage}</Span>
        </div>
      ))
    ) : (
      <Span>No Exceptions</Span>
    )}
  </>
);
